enum GaEvent {
    FromStart = "form_start",
    PageView = "page",
}

enum Form {
    B2cQuoteRequest = "consumer_quote_request",
}

interface StartFormEventData {
    event: GaEvent;
    form_id: string;
    form_name: Form;
}

export interface PageViewTrackingData {
    audienceType: string;
    pageType: string;
    pageTemplate: string;
    locale: string;
    businessUnit: string;
    brandName: string;
    brandId: number;
    categoryId?: number | null;
    categoryName?: string | null;
    typeId?: number | null;
    typeName?: string | null;
}

export class GATracker {
    public static sendFormStartEvent(authCode?: string|null): void {

        const formElement = document.querySelector('[data-authcode]') as HTMLElement;

        if (!formElement && !authCode) {
            return;
        }

        const startFormEventData: StartFormEventData = {
            event: GaEvent.FromStart,
            form_id: authCode ? authCode : formElement.getAttribute('data-authcode'),
            form_name: Form.B2cQuoteRequest,
        };

        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(startFormEventData);
    }

    public static sendPageViewEvent(
            trackingData: PageViewTrackingData,
        ): void {

        let data = {
            event: GaEvent.PageView,
            page_location: window.location.href,
            audience_type: trackingData.audienceType,
            page_type: trackingData.pageType,
            page_template: trackingData.pageTemplate,
            locale: trackingData.locale,
            business_unit: trackingData.businessUnit,
            brand_id: trackingData.brandId,
            brand_name: trackingData.brandName,
            business_category: trackingData.categoryName,
            business_category_id: trackingData.categoryId,
            business_category_sub: trackingData.typeName,
            business_category_sub_id: trackingData.typeId,
        };

        const abVersion = document.body.getAttribute('data-ab');
        if (abVersion) {
            data.ab_test_variant = abVersion;
        }

        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(data);
    }
}

(<any>window).GATracker = GATracker;

